module.exports = __webpack_public_path__ + "static/media/wind-turbine.14f4e2e4.svg";